import { Route } from 'react-router-dom';
import { NotFoundPage } from '../pages/errors/NotFoundPage';
import { ServerErrorPage } from '../pages/errors/ServerErrorPage';

export const errorRoutes = (
  <>
    <Route path="/404" element={<NotFoundPage />} />
    <Route path="/500" element={<ServerErrorPage />} />
  </>
);
